import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取MSC补充信息
export function getMscSupplement(params) {
  return request({
    url: URL.seaExport.getMscSupplementUrl,
    method: 'get',
    params
  })
}

// 获取msc信息
export function searchMscDataFunc(data) {
  return request({
    url: URL.seaExport.searchMscDataUrl,
    method: 'post',
    data
  })
}
